import {EzLayout} from '@ezcater/recipe';
import type {DriverProgressAssignmentQuery} from 'services/graphql/types';
import CallCard from './CallCard';
import DeliveryAddressCard from '../DeliveryAddressCard/DeliveryAddressCard';
import OrderItemsCard from '../OrderItemsCard';
import {DriverProgressContainer} from '../DriverProgress.styles';

interface Props {
  readonly assignment: NonNullable<
    NonNullable<DriverProgressAssignmentQuery['me']>['driverAccount']
  >['assignment'];
}

/**
 * Step 2: Delivery is in progress
 */
const InProgress = ({assignment}: Props) => {
  return (
    <DriverProgressContainer>
      <EzLayout layout="stack">
        <DeliveryAddressCard
          type="dropoff"
          isMapLinkDisabled={false}
          eventAt={assignment.eventAt}
          distanceInMiles={assignment.distanceInMiles ?? null}
          dropoffWindow={assignment.dropoffWindow}
          durationInMinutes={assignment.durationInMinutes ?? null}
          address={assignment.dropoffAddress}
          driverAskFor={assignment.driverAskFor}
          deliverySetup={assignment.deliverySetup}
        />
        {!!assignment.orderItems.length && <OrderItemsCard items={assignment.orderItems} />}
        <CallCard driverAssignmentId={assignment.id} phone={assignment.dropoffAddress?.phone} />
      </EzLayout>
    </DriverProgressContainer>
  );
};

export default InProgress;
